export default __webpack_public_path__ + "static/media/Covid Tracker Portfolio Image.3af0881b.png";